import React from "react";
import "./PayrollDescription.css";

export default function PayrollDescription() {
  return (
    <div className="PayrollDescription">
      <h1>Unlock Payroll Ease with a Single Click!</h1>
      <h3>Simplify Payroll Taxes with Confidence</h3>
      <p>
        Experience the convenience of this user-friendly tool that offers
        estimations for your tax deductions and withholdings, guaranteeing
        precise and effortless payroll management. Don't hesitate to give it a
        try today!
      </p>
    </div>
  );
}
